<template>
	<div class="con">
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="修改信息" goBack="true"></head-top>
		<div class="bg_a">
			<div class="changeName font_size_a">
				<div class="flex_c infoCell">
					<div>修改头像</div>
					<van-uploader :max-count="1" :before-read="beforeRead" :after-read="afterRead">
						<img :src='customAvatar?(resourceDomain+customAvatar):(resourceDomain+"static/icon/mine/img_upload.png")' class="img_upload">
					</van-uploader>
				</div>
				<div class="flex_c infoCell">
					<div>修改姓名</div>
					<input type="text" v-model="realName" label="" placeholder="请输入姓名">
				</div>
			</div>
		</div>
		<van-button round block type="info" @click="onSubmitInfo" class="submitInfoBtn">提交</van-button>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import api from '@/apis/api'
	import * as imageConversion from 'image-conversion'
	import {
		mapGetters,
		mapActions
	} from 'vuex';
	export default {
		name: 'ChangeName',
		components: {
			headTop: headTop
		},
		data() {
			return {
				resourceDomain: api.resourceDomain,
				realName: '',
				customAvatar: "",
			}
		},
		beforeRouteEnter(to, from, next) {
			// 添加背景色
			document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
			next()
		},
		beforeRouteLeave(to, from, next) {
			// 去除背景色
			document.querySelector('body').setAttribute('style', '')
			next()
		},
		created() {
			// 获取用户信息
			this.getUserInfo()
		},
		methods: {
			// 调用组件中的登录成功里的自定义的更新数据事件
						updatePage() {
							this.getUserInfo()
						},
						
			// 读取文件前置的处理
			beforeRead(file) {
				// if (file.type !== 'image/jpeg') {
				// 	Toast('请上传 jpg 格式图片');
				// 	return false;
				// }
				return true
			},

			//文件读取完成后的回调函数
			async afterRead(file) {
				this.$toast.loading({
					overlay: true,
					message: '上传中...',
					duration: 0
				})

				var fileBlob = new Blob([file.file], {
					type: "multipart/form-data"
				}); //转二进制
				var packetFileBlob = fileBlob.slice(0, 20) //分片前20位二进制

				// 二进制
				let fdBlob = new FormData()
				fdBlob.append('file', packetFileBlob, file.file.name)

				// 文件流
				var blob = file.file
				//压缩图片
				if (file.file.size > 204800) {
					blob = await imageConversion.compressAccurately(file.file, 200)
				}
				let fd = new FormData()
				fd.append('file', blob, file.file.name)

				// 先对图片校验
				api.upLoadImg("/upload/imageFileHeadCheck", fdBlob).then(res => {
					this.$toast.clear()
					if (!res.success) {
						this.$toast.fail("图片上传失败,请重新上传!");
					} else {
						// 成功后,再走接口去上传到阿里云
						api.upLoadImg("/upload/userCustomAvatar", fd).then(r => {
							if (!r.success) {
								this.$toast.fail("图片上传失败,请重新上传!");
							} else {
								this.customAvatar = r.data
								this.$toast.success("上传成功!");
							}
						})
					}
				})

			},

			// 提交
			onSubmitInfo() {
				var realName = this.realName.trim()
				if (!realName) {
					this.$toast.fail('请输入姓名');
					return false
				}

				if (!(this.customAvatar)) {
					this.$toast.fail("请上传头像");
					return false
				}

				this.$toast.loading({
					overlay: true,
					message: "提交中...",
					duration: 0,
				});
				api.post("/user/updateUserInfo", {
					realName: realName,
					customAvatar: this.customAvatar,
				}).then(res => {
					this.$toast.clear();
					if (res.code == 20000) {
						this.$toast.success({
							message: '修改成功',
							forbidClick: true,
							duration: 1500
						});
						setTimeout(() => {
							this.$router.go(-1)
						}, 1500);
					} else {
						this.$toast(res.message);
					}
				})
			},

			// 获取用户信息
			getUserInfo() {
				api.post("/user/getUserData", {}).then((res) => {
					console.log(res, "-----getUserData------");
					if (res.success) {
						this.realName = res.data.realName
						this.customAvatar = res.data.customAvatar
					} else {
						this.$toast(res.message);
						this.realName = ""
						this.customAvatar = ""
					}
				});
			},
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
	.img_upload {
		display: block;
		width: 50px;
		height: 50px;
		border-radius: 50%;
		background-color: #fff;
	}

	.infoCell {
		padding: 10px 0;
		width: 100%;
		height: 50px;
		line-height: 50px;
		border-bottom: 1px solid #eee;
	}

	.changeName input {
		width: 250px;
		color: #999;
		font-size: 15px;
		border: unset;
		background: unset;
		text-align: right;
	}

	.changeName input::placeholder {
		color: #999 !important;
	}

	.submitInfoBtn {
		position: fixed;
		left: 15px;
		right: 15px;
		width: 345px !important;
		bottom: 20px;
		z-index: 999;
		font-size: 18px !important;
	}

	.con {
		padding-top: 48px;
		position: relative;
	}

	.changeName {
		width: 345px;
		padding: 0 15px;
	}
</style>
